const currentYear = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="bg-stone-900 border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <p
                className="text-white font-bold text-xl"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Fletcher &amp; Cooley
              </p>
              <p className="text-amber-600 text-xs tracking-widest uppercase">General Contractors</p>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed max-w-sm mb-6">
              Licensed Georgia general contractor specializing in commercial build-outs and tenant improvements throughout Henry County and Metro Atlanta. Delivering structured, code-compliant construction since day one.
            </p>
            <a
              href="tel:6783948805"
              className="inline-flex items-center gap-2 text-amber-500 font-bold text-lg hover:text-amber-400 transition-colors cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-base" />
              </span>
              (678) 394-8805
            </a>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wide">Services</h4>
            <ul className="space-y-2.5">
              {[
                'Commercial Build-Outs',
                'Tenant Improvements',
                'Restaurant Construction',
                'Medical Facilities',
                'Office Spaces',
                'Commercial Roofing',
              ].map((s) => (
                <li key={s}>
                  <a href="#services" className="text-stone-400 text-sm hover:text-amber-500 transition-colors cursor-pointer">
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wide">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-amber-600 text-sm" />
                </span>
                <span className="text-stone-400 text-sm">Stockbridge, GA 30281<br />Henry County, Georgia</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-amber-600 text-sm" />
                </span>
                <a href="tel:6783948805" className="text-stone-400 text-sm hover:text-amber-500 transition-colors cursor-pointer">
                  (678) 394-8805
                </a>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-amber-600 text-sm" />
                </span>
                <span className="text-stone-400 text-sm">Mon–Fri: 8AM–5PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-stone-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-xs">
            &copy; {currentYear} Fletcher &amp; Cooley, Inc. All rights reserved. Licensed Georgia General Contractor.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-stone-500 text-xs hover:text-stone-300 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-stone-500 text-xs hover:text-stone-300 transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
